import { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { MSG } from 'commons/constants';
import { message } from 'antd';

interface CrmCodeprops {
  params: CrmCodeListReqDto;
  onInsertCompleted?: (id: string | number | undefined) => void;
}

const useCrmCode = ({params, onInsertCompleted}: CrmCodeprops) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [codeList, setCodeList] = useState<CrmCodeListDto[]>();

  const { isLoading, refetch } = useQuery(
    [endpoints.crm.code, params],
    () =>
      fetcher.crm.getCrmCodeList(params),
    {
      enabled: (!!params.searchValue &&  params.searchValue != '') || (!!params.company && params.company > 0),  
      onSuccess: (res: CrmCodeListResDto) => {
        switch (res.code) {
          case 200:
            setCodeList(res.result?.list);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: crmInsert } = useMutation(
    [endpoints.crm.add],
    fetcher.crm.postCrmAdd,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            onInsertCompleted?.(res.result?.id);
            refetch();
            break;
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  return { isLoading, codeList, refetch, crmInsert  };
};

export default useCrmCode;
